module.exports = __webpack_public_path__ + "static/proboard2-28a4504d109a696a3d88d287a0a193e0.png";